var _path, _mask, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _mask2, _g2, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 140,
    viewBox: "0 0 223 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.0126 139.338C90.052 139.338 116.025 113.365 116.025 81.3252C116.025 49.2857 90.052 23.3126 58.0126 23.3126C25.9731 23.3126 0 49.2857 0 81.3252C0 113.365 25.9731 139.338 58.0126 139.338Z",
    fill: "#EFEFFF"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 23,
    width: 117,
    height: 117
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.0126 139.338C90.052 139.338 116.025 113.365 116.025 81.3252C116.025 49.2857 90.052 23.3126 58.0126 23.3126C25.9731 23.3126 0 49.2857 0 81.3252C0 113.365 25.9731 139.338 58.0126 139.338Z",
    fill: "#EFEFFF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2717 144.916V133.704C11.1561 133.606 10.0683 133.341 9.03639 132.951C7.68369 133.843 5.82896 134.164 4.19736 134.066C-13.3459 125.602 -32.9809 110.513 -25.4365 88.4931C-17.4458 65.2184 12.0625 52.2074 34.5842 49.5717V42.5154C26.2449 32.921 18.2961 3.64976 38.5029 1.30694C48.8363 -10.0864 86.7397 1.99026 74.7049 19.1291C75.3882 29.1 74.0216 45.2347 65.6962 51.5798C72.2784 53.1975 79.0559 53.4067 83.114 59.5287C87.0744 65.4973 87.2557 74.5338 90.3934 81.1858C91.8158 78.0341 93.0151 75.259 96.9617 74.7709C99.8204 68.6629 102.735 67.7285 108.871 67.0034C110.489 66.8081 115.621 68.5931 116.025 68.6071C122.035 68.7326 126.735 64.4793 132.034 69.7367C143.232 80.865 125.229 88.6047 116.318 88.6883C111.311 105.13 95.0093 124.695 76.978 110.318V144.916H12.2717ZM-0.265146 98.4919C0.208996 99.482 2.45419 102.885 12.2856 108.142V88.6047C3.36064 92.7743 0.460011 97.1392 -0.265146 98.4919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.101 76.8628C98.1764 94.7128 89.2514 130.413 71.4014 67.9377",
    stroke: "#704A29",
    strokeWidth: 8.92501,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1348 109.537C90.7583 109.537 90.3678 109.523 89.9774 109.481C79.5463 108.574 72.462 102.439 63.8299 67.9238C61.4592 58.4689 76.6177 54.6758 78.9884 64.1307C84.6921 86.9452 88.8059 88.8279 90.9954 92.2863C92.8919 89.2881 95.2347 84.0307 96.6572 80.8372C97.7867 78.3131 112.025 84.714 110.923 87.1823C106.042 98.1852 100.98 109.537 91.1348 109.537Z",
    fill: "#7A7DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8506 59.0127C35.7006 53.0581 53.5506 53.0581 71.4006 59.0127V139.338H17.8506V59.0127Z",
    fill: "#7A7DFF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 54,
    width: 55,
    height: 86
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8506 59.0127C35.7006 53.0581 53.5506 53.0581 71.4006 59.0127V139.338H17.8506V59.0127Z",
    fill: "#7A7DFF"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.9248 121.39C44.6248 121.39 44.6248 119.759 80.3249 119.759",
    stroke: "white",
    strokeWidth: 1.11563,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9248 132.756C44.6248 132.756 44.6248 127.47 80.3249 127.47",
    stroke: "white",
    strokeWidth: 1.11563,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9248 109.495C44.6248 109.495 44.6248 112.772 80.3249 112.772",
    stroke: "white",
    strokeWidth: 1.11563,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9248 100.946C44.6248 100.946 44.6248 104.614 80.3249 104.614",
    stroke: "white",
    strokeWidth: 1.11563,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9248 91.8959C44.6248 91.8959 44.6248 96.4281 80.3249 96.4281",
    stroke: "white",
    strokeWidth: 1.11563,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9248 85.4949C44.6248 85.4949 44.6248 83.1521 80.3249 83.1521",
    stroke: "white",
    strokeWidth: 1.11563,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9248 77.0999C44.6248 77.0999 44.6248 78.6338 80.3249 78.6338",
    stroke: "white",
    strokeWidth: 1.11563,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9248 71.2846C44.6248 71.2846 44.6248 65.8459 80.3249 65.8459",
    stroke: "white",
    strokeWidth: 1.11563,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.627 63.4752C50.7884 63.4752 55.7832 61.4772 55.7832 59.0127C55.7832 56.5481 50.7884 54.5502 44.627 54.5502C38.4655 54.5502 33.4707 56.5481 33.4707 59.0127C33.4707 61.4772 38.4655 63.4752 44.627 63.4752Z",
    fill: "#373ABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1631 57.8971V36.7002C40.1631 34.2319 42.1573 32.2377 44.6256 32.2377C47.0939 32.2377 49.0881 34.2319 49.0881 36.7002V57.8971C49.0881 60.3514 40.1631 60.3514 40.1631 57.8971Z",
    fill: "#704A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.92713 121.488C-8.92289 112.563 -35.6979 94.7128 17.8521 67.9377",
    stroke: "#FFE5B1",
    strokeWidth: 8.92501,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7748 128.182C25.8962 128.182 25.0316 128.014 24.2228 127.666L23.8741 127.526C22.117 126.801 21.1548 126.397 20.095 126.397C19.0351 126.397 18.0729 126.801 16.3158 127.526L15.9671 127.666C15.1444 128 14.2798 128.182 13.4152 128.182C10.6958 128.182 8.26933 126.564 7.22343 124.054C6.54011 122.408 6.54011 120.581 7.22343 118.936C7.90675 117.276 9.18972 115.993 10.8492 115.31C14.7957 113.678 17.4732 113.009 20.095 113.009C22.7167 113.009 25.3942 113.678 29.3407 115.31C31.2931 116.119 32.0601 117.653 32.3529 118.782C32.7713 120.372 32.59 122.241 31.8369 124.054C30.6376 126.94 29.1315 128.182 26.7748 128.182Z",
    fill: "#704A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.44011 128.474C-6.16241 122.673 -21.5859 113.218 -21.5859 98.1851C-21.5859 85.216 -8.90964 68.9 17.8654 58.9988C21.9095 57.5066 23.9874 60.212 24.852 64.4375C25.7166 68.6629 25.5074 78.2154 21.3657 79.3729C-0.807402 85.6065 -5.95323 95.926 -5.95323 98.1851C-5.95323 101.434 -2.75975 106.887 12.4407 114.487C16.2756 116.426 6.55573 129.032 5.44011 128.474Z",
    fill: "#7A7DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.625 54.5503V43.394",
    stroke: "#704A29",
    strokeWidth: 8.92501,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1138 21.6393C67.8308 34.5945 58.4038 45.2208 50.2597 45.2208C42.1156 45.2208 32.8559 34.5666 31.4056 21.6393C29.9414 8.71198 39.3684 5.12803 41.5439 7.48479C46.871 -3.25311 70.5641 6.95487 69.1138 21.6393Z",
    fill: "#1F3A93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0541 35.5846V26.6596C68.0541 18.655 61.5556 12.1565 53.551 12.1565C45.5464 12.1565 39.0479 18.655 39.0479 26.6596V35.5846C39.0479 43.5893 45.5464 50.0878 53.551 50.0878C61.5696 50.0878 68.0541 43.5893 68.0541 35.5846Z",
    fill: "#FFE5B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0883 25.5439C49.0883 29.2395 46.09 32.2377 42.3945 32.2377V25.5439H49.0883Z",
    fill: "#1F3A93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3945 18.8502L49.0883 25.544H42.3945V18.8502Z",
    fill: "#373ABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0885 23.3128L39.0479 14.3878V25.5441H49.0885V23.3128Z",
    fill: "#1F3A93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1637 23.3127C42.632 23.3127 44.6262 25.3069 44.6262 27.7752V36.7003C39.7035 36.7003 35.7012 32.6979 35.7012 27.7752C35.7012 25.3069 37.7093 23.3127 40.1637 23.3127Z",
    fill: "#FFE5B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.952 76.8628C119.234 79.2335 112.819 79.2335 107.102 76.8628",
    stroke: "#FFC984",
    strokeWidth: 8.92501,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.625 49.554V43.394",
    stroke: "#4F351E",
    strokeWidth: 8.92501,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1138 21.6393C67.8308 34.5945 58.4038 45.2208 50.2597 45.2208C42.1156 45.2208 32.8559 34.5666 31.4056 21.6393C29.9414 8.71198 39.3684 5.12803 41.5439 7.48479C46.871 -3.25311 70.5641 6.95487 69.1138 21.6393Z",
    fill: "#373ABF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0541 35.5846V26.6596C68.0541 18.655 61.5556 12.1565 53.551 12.1565C45.5464 12.1565 39.0479 18.655 39.0479 26.6596V35.5846C39.0479 43.5893 45.5464 50.0878 53.551 50.0878C61.5696 50.0878 68.0541 43.5893 68.0541 35.5846Z",
    fill: "#704A29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0883 25.5439C49.0883 29.2395 46.09 32.2377 42.3945 32.2377V25.5439H49.0883Z",
    fill: "#373ABF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3945 18.8502L49.0883 25.544H42.3945V18.8502Z",
    fill: "#373ABF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0885 23.3128L39.0479 14.3878V25.5441H49.0885V23.3128Z",
    fill: "#373ABF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1637 23.3127C42.632 23.3127 44.6262 25.3069 44.6262 27.7752V36.7003C39.7035 36.7003 35.7012 32.6979 35.7012 27.7752C35.7012 25.3069 37.7093 23.3127 40.1637 23.3127Z",
    fill: "#704A29"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1631 12.1565C40.1631 7.23378 42.8127 2.11584 50.2037 2.11584C57.5947 2.11584 71.4006 7.23378 71.4006 12.1565C71.4006 17.0792 65.4041 21.0815 58.0131 21.0815C50.6221 21.0815 40.1631 17.0792 40.1631 12.1565Z",
    fill: "#373ABF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M124.95 76.8627C119.232 79.2334 112.817 79.2334 107.1 76.8627",
    stroke: "#704A29",
    strokeWidth: 8.92501,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.87 14.3876H127.182C130.878 14.3876 133.876 17.3858 133.876 21.0813V43.3939C133.876 47.0894 130.878 50.0876 127.182 50.0876H104.87C101.174 50.0876 98.1758 47.0894 98.1758 43.3939V21.0813C98.1758 17.3858 101.174 14.3876 104.87 14.3876Z",
    fill: "#F7941D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M178.375 103.638C203.021 103.638 223 83.6583 223 59.0126C223 34.3669 203.021 14.3876 178.375 14.3876C153.729 14.3876 133.75 34.3669 133.75 59.0126C133.75 83.6583 153.729 103.638 178.375 103.638Z",
    fill: "#E4E5FF"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 133,
    y: 14,
    width: 90,
    height: 90
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.375 103.638C203.021 103.638 223 83.6583 223 59.0126C223 34.3669 203.021 14.3876 178.375 14.3876C153.729 14.3876 133.75 34.3669 133.75 59.0126C133.75 83.6583 153.729 103.638 178.375 103.638Z",
    fill: "#E4E5FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223 124.835C223 111.963 223 99.0915 223 86.206C223 71.2706 225.803 56.0981 208.414 49.7669C213.183 41.6228 208.985 24.1633 206.615 15.3917C203.365 3.38474 191.386 -3.09983 179.533 -2.22128C166.522 -1.25905 158.88 6.25748 157.932 19.1709C157.234 28.7513 151.07 45.4299 159.912 52.8488C148.212 60.4908 151.586 77.3508 151.586 89.3577C151.586 101.183 151.586 113.009 151.586 124.835H223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.614 132.644C205.305 132.644 201.805 129.144 201.805 124.835V62.3596C201.805 58.0505 201.038 53.2533 205.152 54.5502C209.572 55.9447 217.423 59.5287 217.423 66.8221V124.835C217.423 129.158 213.923 132.644 209.614 132.644Z",
    fill: "#7A7DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.989 132.644C169.298 132.644 172.798 129.144 172.798 124.835V62.3596C172.798 58.0505 173.565 53.2533 169.452 54.5502C165.031 55.9447 157.18 59.5287 157.18 66.8221V124.835C157.18 129.158 160.68 132.644 164.989 132.644Z",
    fill: "#7A7DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.452 54.5502C178.377 51.5798 196.227 51.5798 205.152 54.5502C205.152 54.5502 209.614 76.8627 209.614 112.563C209.614 118.517 164.989 118.517 164.989 112.563C164.989 76.8627 169.452 54.5502 169.452 54.5502Z",
    fill: "#7A7DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.564 83.5564L187.302 7.83325",
    stroke: "white",
    strokeWidth: 3.34688,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.034 93.0252L196.771 17.3021",
    stroke: "white",
    strokeWidth: 3.34688,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.503 102.494L206.226 26.7571",
    stroke: "white",
    strokeWidth: 3.34688,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.972 111.963L215.695 36.226",
    stroke: "white",
    strokeWidth: 3.34688,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.44 121.432L225.164 45.6948",
    stroke: "white",
    strokeWidth: 3.34688,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.895 130.887L234.632 55.1637",
    stroke: "white",
    strokeWidth: 3.34688,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.364 140.356L244.101 64.6326",
    stroke: "white",
    strokeWidth: 3.34688,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.833 149.824L253.57 74.0874",
    stroke: "white",
    strokeWidth: 3.34688,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.302 159.293L263.025 83.5564",
    stroke: "white",
    strokeWidth: 3.34688,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.838 3.23132C172.979 3.23132 163.873 11.222 163.873 21.0813C163.873 27.7751 158.155 42.9894 162.757 47.8564C169.66 55.1498 196.017 55.1498 202.92 47.8564C207.522 42.9894 201.804 27.7751 201.804 21.0813C201.804 11.222 192.698 3.23132 182.838 3.23132Z",
    fill: "#373ABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.532 66.8221C197.537 66.8221 204.036 62.8198 204.036 57.8971C204.036 56.4189 203.436 55.0243 202.404 53.7971C195.557 52.2074 185.6 51.9006 177.539 52.8768C175.95 54.3131 175.029 56.0284 175.029 57.8971C175.029 62.8337 181.514 66.8221 189.532 66.8221Z",
    fill: "#FFE5B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.533 63.4752C195.697 63.4752 200.689 60.477 200.689 56.7815C200.689 55.4288 200.02 54.1877 198.877 53.1278C193.424 52.305 186.856 52.1098 180.873 52.556C179.311 53.7135 178.377 55.1778 178.377 56.7815C178.377 60.477 183.369 63.4752 189.533 63.4752Z",
    fill: "#FFE5B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.838 53.4344V38.9313C182.838 36.4629 184.832 34.4688 187.3 34.4688C189.769 34.4688 191.763 36.4629 191.763 38.9313V53.4344C191.763 55.9027 182.838 55.9027 182.838 53.4344Z",
    fill: "#FFC984"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.221 33.0186V24.7769C167.221 17.3859 173.217 11.3894 180.608 11.3894C187.999 11.3894 193.996 17.3859 193.996 24.7769V33.0186C193.996 40.4096 187.999 46.4061 180.608 46.4061C173.217 46.4061 167.221 40.4096 167.221 33.0186Z",
    fill: "#FFE5B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.043 9.92505C175.043 21.0813 190.662 17.4555 190.662 24.4282V9.92505H175.043Z",
    fill: "#373ABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.457 14.3877H190.647V25.544H198.457V14.3877Z",
    fill: "#373ABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.457 30.0065H191.764V43.394H198.457V30.0065Z",
    fill: "#373ABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.88 21.0813C191.025 21.0813 189.533 22.5734 189.533 24.4282V34.4688C193.229 34.4688 196.227 31.4706 196.227 27.7751V24.4282C196.227 22.5874 194.721 21.0813 192.88 21.0813Z",
    fill: "#FFE5B1"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M182.837 3.23132C172.977 3.23132 163.871 11.222 163.871 21.0813C163.871 27.7751 158.153 42.9894 162.755 47.8564C169.658 55.1498 196.015 55.1498 202.918 47.8564C207.52 42.9894 201.802 27.7751 201.802 21.0813C201.802 11.222 192.696 3.23132 182.837 3.23132Z",
    fill: "#373ABF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M189.53 66.822C197.535 66.822 204.034 62.8197 204.034 57.897C204.034 56.4187 203.434 55.0242 202.402 53.797C195.555 52.2073 185.598 51.9005 177.538 52.8766C175.948 54.313 175.027 56.0283 175.027 57.897C175.027 62.8336 181.512 66.822 189.53 66.822Z",
    fill: "#FFE5B1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M189.531 63.4751C195.695 63.4751 200.688 60.4769 200.688 56.7814C200.688 55.4287 200.018 54.1875 198.875 53.1277C193.422 52.3049 186.854 52.1097 180.871 52.5559C179.309 53.7134 178.375 55.1776 178.375 56.7814C178.375 60.4769 183.367 63.4751 189.531 63.4751Z",
    fill: "#FFE5B1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M182.837 53.4344V38.9313C182.837 36.4629 184.831 34.4688 187.299 34.4688C189.768 34.4688 191.762 36.4629 191.762 38.9313V53.4344C191.762 55.9027 182.837 55.9027 182.837 53.4344Z",
    fill: "#FFC984"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M167.219 33.0185V24.7768C167.219 17.3858 173.215 11.3893 180.606 11.3893C187.997 11.3893 193.994 17.3858 193.994 24.7768V33.0185C193.994 40.4095 187.997 46.406 180.606 46.406C173.215 46.406 167.219 40.4095 167.219 33.0185Z",
    fill: "#FFE5B1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M175.041 9.92505C175.041 21.0813 190.66 17.4555 190.66 24.4282V9.92505H175.041Z",
    fill: "#373ABF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M198.456 14.3877H190.646V25.544H198.456V14.3877Z",
    fill: "#373ABF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M198.455 30.0063H191.762V43.3939H198.455V30.0063Z",
    fill: "#373ABF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M192.877 21.0813C191.022 21.0813 189.53 22.5734 189.53 24.4282V34.4688C193.226 34.4688 196.224 31.4706 196.224 27.7751V24.4282C196.224 22.5874 194.718 21.0813 192.877 21.0813Z",
    fill: "#FFE5B1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M122.51 41.3578L116.346 38.1365L110.406 41.7622C109.848 42.0969 109.151 41.6228 109.262 40.9813L110.42 34.1202L105.148 29.588C104.66 29.1696 104.883 28.3608 105.525 28.2632L112.4 27.2452L115.077 20.8303C115.328 20.2307 116.165 20.2028 116.458 20.7885L119.554 27.022L126.485 27.5798C127.126 27.6356 127.419 28.4166 126.959 28.8768L121.994 33.7437L123.598 40.5072C123.737 41.1487 123.082 41.6646 122.51 41.3578Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M116.025 5.4625V1",
    stroke: "#7A7DFF",
    strokeWidth: 1.11563,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M102.637 9.04643L101.521 7.10803",
    stroke: "#7A7DFF",
    strokeWidth: 1.11563,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8336 18.85L88.9707 16.6188",
    stroke: "#7A7DFF",
    strokeWidth: 1.11563,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2498 32.2375H87.0186",
    stroke: "#7A7DFF",
    strokeWidth: 1.11563,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8336 45.6251L88.9707 47.8564",
    stroke: "#7A7DFF",
    strokeWidth: 1.11563,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M102.637 55.4147L101.521 57.3531",
    stroke: "#7A7DFF",
    strokeWidth: 1.11563,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M116.025 59.0126V63.4751",
    stroke: "#7A7DFF",
    strokeWidth: 1.11563,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M129.412 55.4147L130.528 57.3531",
    stroke: "#7A7DFF",
    strokeWidth: 1.11563,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M139.216 45.6251L143.079 47.8564",
    stroke: "#7A7DFF",
    strokeWidth: 1.11563,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M142.799 32.2375H145.03",
    stroke: "#7A7DFF",
    strokeWidth: 1.11563,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M139.216 18.85L143.079 16.6188",
    stroke: "#7A7DFF",
    strokeWidth: 1.11563,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M129.412 9.04643L130.528 7.10803",
    stroke: "#7A7DFF",
    strokeWidth: 1.11563,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIllustration);
export default __webpack_public_path__ + "static/media/share-illustration.01317328.svg";
export { ForwardRef as ReactComponent };